// src/App.js
import React from 'react';
import { HelmetProvider} from "react-helmet-async";
import MainRoutes from './MainRoutes';

function App() {
  return (
    <HelmetProvider>
    <div className="App">
        <MainRoutes/>
    </div>
    </HelmetProvider>
  );
}

export default App;